import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import type { TrialPlatform } from '~/features/trial/types/trial.types';

const TrialEnrichmentPage = lazy(() => import('~/features/trial/pages/trial-enrichment-page'));

export const Route = createFileRoute('/_authenticated/_tenant/trial/$platform/enrichment/$id')({
  /** `step` activates a specific wizard step on mount — used when resuming a
   *  trial job from the jobs list (e.g. step=1 for CONTENT_SCORING stage). */
  // Returning `{ step?: number }` (optional key) tells TanStack Router the
  // search param is not required for navigation — callers can omit `search` entirely.
  validateSearch: (search: Record<string, unknown>): { step?: number } => {
    const step = typeof search.step === 'number' ? search.step : undefined;
    return step !== undefined ? { step } : {};
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { platform, id } = Route.useParams();
  const { step } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <TrialEnrichmentPage
        platform={platform as TrialPlatform}
        trialId={id}
        initialStep={step ?? 0}
      />
    </Suspense>
  );
}
